import React, { SyntheticEvent, useEffect, useRef } from 'react';

import styles from './VerticalScroll.module.scss';

type VerticalScrollProps = {
	scroll: number;
	ganttHeight: number;
	ganttFullHeight: number;
	headerHeight: number;
	onScroll: (event: SyntheticEvent<HTMLDivElement>) => void;
}

const VerticalScroll: React.FC<VerticalScrollProps> = ({
	scroll,
	ganttHeight,
	ganttFullHeight,
	headerHeight,
	onScroll,
}) => {
	const scrollRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (scrollRef.current) {
			scrollRef.current.scrollTop = scroll;
		}
	}, [scroll]);

	return (
		<div
			ref={scrollRef}
			className={styles.scroll}
			onScroll={onScroll}
			style={{
				height: ganttHeight,
				marginTop: headerHeight,
				marginLeft: '-1rem',
			}}
		>
			<div style={{ height: ganttFullHeight, width: 1 }} />
		</div>
	);
};

export default VerticalScroll;
